import { ErrorResponse, GlobalStatus, GlobalVariableValues, MessageParameters, MessageRequest, SaleOrderStatusEnum, SoStatusEnum, StatusEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import { AllGrnResponseModel, GrnDetailsDto, GrnDetailViewModel, GrnDetailViewResponseModel, grnItemsDataModel, grnQtyDto, GrnQtyResponseModel, PoVendorDataModel, GrnReturnAutoFillDto, GrnReturnAutoFillModel, GrnNumberResponseModel, GrnNumberDto, GrnItemReceivedQtyResponse, PoNumbersModel, AllGrnDto, AllGrnReportResponse, AllGrnReportDto, GrnDetailsForReturn, GrnItemsForReturn, GrnItemReturnResponse } from '@gtpl/shared-models/procurement-management';
import { forwardRef, Inject, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Not, Repository } from 'typeorm';
import { PurchaseOrderIdRequest } from '../po-creation/dto/po-id.request';
import { ItemCategoryService, ItemsService, ItemSubCategoryService, SizesService, TaxesService, UnitcodeService, VendorsPriceListService, VendorsService } from '@gtpl/shared-services/masters'
import { GrnQtyRequest } from './dto/grn-qty-request';
import { GrnIdRequest } from './dto/grn-request';
import { grnResponse } from './dto/grn-response';
import { GrnAdapter } from './dto/grn.adapter';
import { GrnDto } from './dto/grn.dto';
import { GrnItems } from './grn-items.entity';
import { Grn } from './grn.entity';
import {Cron} from '@nestjs/schedule';
import { GrnRepository } from './repository/grn-repository';
import { CommonResponse, ItemCategoryReq, ItemRequest, ItemSubCategoryRequest, SizeRequest, SizesDropDownDto, VendorItemRequest } from '@gtpl/shared-models/masters';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { PoItems } from '../po-creation/po-creation-items.entity';
import { PoItemsRepository } from '../po-creation/repository/po-items.repository';
import { GrnItemReceivedQtyRequest } from './dto/grn-item-received-qty-request';
import { isEmpty, Matches } from 'class-validator';
import { Stock } from '../stock/stock.entity';
import { StockDto } from '../stock/dto/stock.dto';
import { StockAdapter } from '../stock/dto/stock.adapter';
import { PoRepository } from '../po-creation/repository/po-repository';
import { StockRepository } from './repository/stock-repository';
// import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { BomUpdateRequest, SoRequest } from '@gtpl/shared-models/sale-management';
import { saleOrder, SaleOrderService } from '@gtpl/shared-services/sale-management';
import { PurchaseOrderService } from '@gtpl/shared-services/procurement';
import { PoRequest } from "@gtpl/shared-models/procurement-management";
import { PoCreationService } from '../po-creation/po-creation.service';
import { IsNull } from 'typeorm';
import { GrnReportRequest } from './grn-report-request';
import appSettings from 'apps/services/config';
import Link from 'antd/lib/typography/Link';
import { StockService } from '../stock/stock.service';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import {whatsApp} from '../../../../whatsapp';
import { SaleOrderIdRequest } from '@gtpl/shared-models/warehouse-management';
import {  WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'
import { Tag} from 'antd';
import {ArrowDownOutlined } from '@ant-design/icons';
import { link } from 'fs';
import { error } from 'console';
import { BroadCastMessageRequest, WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
import { invoiceNumberRequest } from './dto/invoice-number-req';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { AssetService } from '@gtpl/shared-services/asset-management';
import { AssetDto } from "libs/shared-models/asset-management/src/lib/open-assets/assets.dto";
import { isNull } from 'util';


let moment = require('moment')
const grnTable = appSettings.procure_db + '.grn';
const poTable = appSettings.procure_db + '.purchase_order';
const poItemsTable = appSettings.procure_db + '.purchase_order_items';
const soTable = appSettings.sales_db + '.sale_order';
const soInvTable = appSettings.sales_db + '.so_invoice_details';
const vendorsTable = appSettings.masters_db + '.vendors';


@Injectable()
export class GrnService {
  constructor(
    private logService:LogsService,

    @InjectRepository(Grn)
    private grnRepository: Repository<Grn>,

    @InjectRepository(PoItems)
    private poItemsRepository: Repository<PoItems>,
    // @InjectRepository(Stock)
    private stockRepo: StockRepository,
    @InjectRepository(GrnItems)
    private GrnItemsRepository: Repository<GrnItems>,
    private grnAdapter: GrnAdapter,
    private stockAdapter: StockAdapter,
    private itemCategoryService: ItemCategoryService,
    private itemService: ItemsService,
    private grnRepo: GrnRepository,
    private sizeService: SizesService,
    private stockService: StockService,
    private soService: SaleOrderService,

    private wpService: WhatsAppNotificationService,
    // private poRepo: PoRepository,
    private vendorService: VendorsService,
    // @InjectRepository(PoItemsRepository)
    private poItemRepo: PoItemsRepository,
    private saleService: SaleOrderService,
    private vendorPriceListService: VendorsPriceListService,
    // private poService: PurchaseOrderService,
    // @Inject(forwardRef(() => PoCreationService))
    private poService: PoCreationService,
    private taxService: TaxesService,
    private subCategoryService: ItemSubCategoryService,
    private wtsAppBroadCatService : WhatsappBroadCastService,
    private assetService : AssetService,


  ) { }

  async createGrn(grnDto: GrnDto, isUpdate: boolean): Promise<grnResponse> {
    const manager = new GenericTransactionManager();
    console.log(grnDto,'grnDtokk')
    const managerr = getManager();

    try {
      let count;
      let today = new Date();
      let CurrentYear = today.getFullYear();
      let CurrentMonth = today.getMonth();
      let toDate = 0;
      let finYear = '';
      if (!isUpdate) {
        if (CurrentMonth < 4) {
          toDate = (CurrentYear);
        } else {
          toDate = (CurrentYear + 1);
        }
        finYear = toDate.toString().substr(-2)
        let grnInfo = this.grnRepo
          .createQueryBuilder('Grn')
          .select([
            'max(Grn.grn_id) as MaxGrnId'
          ])

        const grnData = await grnInfo.getRawOne();
        count = grnData.MaxGrnId
        count = count + 1;
        var refNo = count + "";
        while (refNo.length < 4) refNo = "0" + refNo;
        const grnEntity = await this.getGrnById(grnDto.grnId);
        if (grnEntity) {
          throw new ErrorResponse(11104, 'Grn already exists');
        }
      }
      const vendorItemMap = new Map<Number, Map<Number, Number>>();
      let vendorPriceStatus = true;
      for (const grnItem of grnDto.grnItemsInfo) {
        console.log(grnItem,'grnItem')
        const vendorItemReq = new VendorItemRequest(grnDto.vendorId, grnItem.itemId);
        const vedorPriceData = await this.vendorPriceListService.GetItemPriceTaxForVendorIdItemId(vendorItemReq);
        if (vedorPriceData.status) {
          if (!(vendorItemMap.has(grnDto.vendorId))) {
            vendorItemMap.set(grnDto.vendorId, new Map<Number, number>());
            if (!(vendorItemMap.get(grnDto.vendorId).has(grnItem.itemId))) {
              vendorItemMap
                .get(grnDto.vendorId)
                .set(grnItem.itemId, vedorPriceData.data.unitPrice);
            }
          } else {
            if (!(vendorItemMap.get(grnDto.vendorId).has(grnItem.itemId))) {
              vendorItemMap
                .get(grnDto.vendorId)
                .set(grnItem.itemId, vedorPriceData.data.unitPrice);
            }
          }
        } else {
          vendorPriceStatus = false;
        }
      }
      const grnNumber = 'GRN/' + finYear + '/' + refNo;


      const convertedGrnEntity: Grn = this.grnAdapter.convertDtoToEntity(grnDto, isUpdate, count, vendorPriceStatus, vendorItemMap, grnNumber);

      // console.log(convertedGrnEntity);
      await manager.startTransaction();

      //saving into GRN and GRN Items
      const savedEntity: Grn = await manager.getRepository(Grn).save(convertedGrnEntity);
      const savedGrnDto: GrnDto = this.grnAdapter.convertEntityToDto(savedEntity);
      for(const grnItemRecord of grnDto.grnItemsInfo){
          //asset saving if GRN item is an asset
          if(grnItemRecord.isAsset == GlobalStatus.YES){
            console.log('saveresultyess',grnItemRecord.isAsset)
            for (let i = 0; i < grnItemRecord.acceptedQuantity; i++) {
              //asset code need autgenerate
              const assetDto = new AssetDto(null,grnItemRecord.itemId,'asset code',null,grnItemRecord.itemId,savedGrnDto.grnId,grnItemRecord.acceptedQuantity,null,null,null,null,null,null,grnDto.invoiceNumber,null,grnItemRecord.unitPrice,grnDto.grnDate,'Asset','GRN',null,'No',null,null,null,1,null,null,null,null,null,null,null,null,null,grnDto.createdUser,true,undefined)
              console.log(assetDto,'assetDtoggg')
              const assetObjSave = await this.assetService.createAssets(assetDto)
              if(!assetObjSave.status){
                await manager.releaseTransaction();
                throw new ErrorResponse(1111, 'Something went wrong in Asset creation')
              }
              console.log('saveresult',assetObjSave)
            }
          }
      }


      let itemcategoryId
      // let bulkStockId = 0
      for (const grnItem of savedGrnDto.grnItemsInfo) {
        const itemData = grnItem.itemId
        if(grnItem.saleOrderId > 0){
          let isManuallyAddedItem
          const bomData = await this.soService.getBomDataById(new SaleOrderIdRequest(grnItem.saleOrderId,undefined,grnItem.itemId,'',''));
          console.log(bomData)
          if(bomData.data.status){
            const packCat = bomData.data.data.packingCategory;
            if(packCat != 'Added In PO'){
              const updatePackingBOMGRN = await this.soService.updatePackingBOMGRNData(new BomUpdateRequest(grnItem.itemId,grnItem.saleOrderId,grnItem.acceptedQuantity,undefined));
              if(!updatePackingBOMGRN.status){
                throw new ErrorResponse(1111, 'Something went wrong in packing BOM log  updation')
              }
            }
          }else{
            throw new ErrorResponse(1111, 'Something went wrong in getting BOM')
          }
        }
        if(grnItem.itemCategoryId == 33){
          const existingStock = await manager.getCustomRepository(StockRepository).find({where:{itemId:grnItem.itemId,unitId:grnDto.unitId,saleOrderId:0,locationId:0}})
          
            const stockObj = new Stock()
            stockObj.createdUser = grnItem.createdUser
            stockObj.itemCategoryId = grnItem.itemCategoryId
            stockObj.itemId = grnItem.itemId
            stockObj.itemSubCategoryId = grnItem.itemSubCategoryId
            stockObj.physicalQuantity = grnItem.acceptedQuantity
            stockObj.saleOrderId = 0
            stockObj.unitId = grnDto.unitId,
            stockObj.unitPrice = grnDto.unitId,
            stockObj.sizeId = grnItem.unitPrice
            if(existingStock.length > 0){
              stockObj.stockId = existingStock[0].stockId
            }
            const saveStock = await manager.getCustomRepository(StockRepository).save(stockObj)
            if(!saveStock){
              throw new ErrorResponse(1111, 'Something went wrong in Inventory Update')
            }
        }
      //   let stockData
      //   let toBeMovedBulkQty
      //   let BulkstockData
      //   let existingStockId
      //   let existingStockQty
      //   let toBeMoved = false
      //   let soStatus = SaleOrderStatusEnum.OPEN;
      //   let stockAcceptedQty
      //   let isTotalMoved = false
      //   let isOnlyInsert = false
      //   let isInsertAndInsert = false
      //   let stockBulkAcceptedQty
        
      //   //check weathre saleorder cancelled or not
      //   const soStatusInfo = await this.saleService.getSoStatusBySoId({ saleOrderId: grnItem.saleOrderId });
      //   const bomStatusInfo = await this.saleService.getBomDataById({ saleOrderId: grnItem.saleOrderId, plantId: null, itemId: grnItem.itemId })
      //   // console.log('bomStatusInfo');
      //   // console.log(bomStatusInfo);
      //   if (bomStatusInfo.data.status) {
      //     // console.log('one')
      //     const existedstockData = await this.stockRepo.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: grnItem.saleOrderId, itemId: grnItem.itemId, unitId: grnDto.unitId, locationId: (grnDto.locationId > 0 ? grnDto.locationId : 0) } })
      //     // console.log('existedstockData')
      //     // console.log(existedstockData)
      //     // console.log(bomStatusInfo.data.data.isRequired)

      //     // if(existedstockData){
      //       if (existedstockData && bomStatusInfo.data.data.isRequired == GlobalStatus.NO || (bomStatusInfo.data.data.isRequired == GlobalStatus.YES && bomStatusInfo.data.data.isQtyRevised == GlobalStatus.YES && existedstockData && (Number(bomStatusInfo.data.data.quantity) < (Number(existedstockData.physicalQuantity) + Number(grnItem.acceptedQuantity))))) {
      //       console.log('two')
  
      //         toBeMovedBulkQty = (Number(grnItem.acceptedQuantity)) - (bomStatusInfo.data.data.quantity - Number(existedstockData.physicalQuantity))
      //         toBeMoved = true
      //         if (bomStatusInfo.data.data.quantity <= Number(existedstockData.physicalQuantity)) {
      //           isOnlyInsert = true
      //           stockAcceptedQty = grnItem.acceptedQuantity
      //         }
      //         if (bomStatusInfo.data.data.quantity > Number(existedstockData.physicalQuantity) && (Number(bomStatusInfo.data.data.quantity) < (Number(existedstockData.physicalQuantity) + Number(grnItem.acceptedQuantity)))) {
      //           isInsertAndInsert = true
      //           stockAcceptedQty = (bomStatusInfo.data.data.quantity - Number(existedstockData.physicalQuantity))
      //           stockBulkAcceptedQty = Number(grnItem.acceptedQuantity) - (bomStatusInfo.data.data.quantity - Number(existedstockData.physicalQuantity))
      //         }
  
  
      //       } else {
      //       console.log('three')
  
      //         if (soStatusInfo.data.status) {
      //       console.log('four')
  
      //           stockData = await this.stockRepo.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: 0, itemId: grnItem.itemId, unitId: grnDto.unitId, locationId: (grnDto.locationId > 0 ? grnDto.locationId : 0) } })
      //           soStatus = SaleOrderStatusEnum.CANCELLED;
      //           stockAcceptedQty = grnItem.acceptedQuantity
      //         } else {
      //       console.log('five')
  
      //           stockData = await this.stockRepo.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: grnItem.saleOrderId, itemId: grnItem.itemId, unitId: grnDto.unitId, locationId: (grnDto.locationId > 0 ? grnDto.locationId : 0) } })
      //           stockAcceptedQty = grnItem.acceptedQuantity
      //         }
      //       }
      //     // }

      //   } else {
      //     console.log('five')

      //     stockData = await this.stockRepo.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: grnItem.saleOrderId, itemId: grnItem.itemId, unitId: grnDto.unitId, locationId: (grnDto.locationId > 0 ? grnDto.locationId : 0) } })
      //     stockAcceptedQty = grnItem.acceptedQuantity
      //   }
      //   if (toBeMoved) {
      //     console.log('six')

      //     stockData = await this.stockRepo.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: 0, itemId: grnItem.itemId, unitId: grnDto.unitId, locationId: (grnDto.locationId > 0 ? grnDto.locationId : 0) } })
      //     if (isInsertAndInsert) {
      //       // stockData = await this.stockRepo.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: grnItem.saleOrderId, itemId: grnItem.itemId, unitId: grnDto.unitId, locationId: (grnDto.locationId > 0 ? grnDto.locationId : 0) } })
      //       const bulkExistingData = await this.stockRepo.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: 0, itemId: grnItem.itemId, unitId: grnDto.unitId, locationId: (grnDto.locationId > 0 ? grnDto.locationId : 0) } })
      //       if (bulkExistingData) {
      //         bulkStockId = bulkExistingData.stockId;
      //         const stockUpdate = await manager.getCustomRepository(StockRepository).update({ saleOrderId: 0, itemId: grnItem.itemId }, { physicalQuantity: () => `physical_quantity+${toBeMovedBulkQty}` })
      //         if (!stockUpdate.affected) {
      //           throw new ErrorResponse(1111, 'Something went wrong in stock updation')
      //         }
      //       } else {
      //         const convertedBulkStockEntity: Stock = this.stockAdapter.convertDtoToEntity(grnItem, existingStockId, existingStockQty, grnDto.locationId, savedGrnDto.unitId, soStatus, stockBulkAcceptedQty, isInsertAndInsert, isOnlyInsert);
      //         const savedBulkStockEntity: Stock = await manager.getRepository(Stock).save(convertedBulkStockEntity);
      //         if (savedBulkStockEntity) {
      //           bulkStockId = savedBulkStockEntity.stockId;
      //         }
      //         if (!savedBulkStockEntity) {
      //           throw new ErrorResponse(111, 'something went wrong in bulk stock insertion')
      //         }
      //       }
      //     }
      //   }


      //   //check weather the request Item is new or existed against Sale order

      //   if (stockData) {
      //     existingStockId = stockData.stockId;
      //     existingStockQty = stockData.physicalQuantity;

      //   }
        itemcategoryId = grnItem.itemCategoryId;

      //   //saved grn items addition into stock 
      //   // if(stockCheckCount > 0){
      //   // const stockUpdate = await this.stockRepository.update({purchaseOrderId:poId,itemName:itemId},{ receivedQuantity: updatedRecQty} )
      //   // }else{

      //   const convertedStockEntity: Stock = this.stockAdapter.convertDtoToEntity(grnItem, existingStockId, existingStockQty, grnDto.locationId, savedGrnDto.unitId, soStatus, stockAcceptedQty, isInsertAndInsert, isOnlyInsert);
      //   // }

      //   const savedStockEntity: Stock = await manager.getRepository(Stock).save(convertedStockEntity);
      //   const savedStockDto: StockDto = this.stockAdapter.convertEntityToDto(savedStockEntity);
      //   if(!savedStockEntity){
      //     throw new ErrorResponse(111, 'something went wrong in stock saving')
      //   }


      //   //mapping GRn with stock
      //   const itemStockMapUpdate = await manager.getRepository(GrnItems).update({ grnItemId: grnItem.grnItemId }, { stockId: savedStockDto.stockId, bulkStockId: bulkStockId })
      //   if(!itemStockMapUpdate){
      //     throw new ErrorResponse(111, 'something went wrong in stock and Grn mapping')
      //   }


        //Received GRN Qty updation against PO
        const recQty = await manager.getRepository(PoItems).findOne({ select: ['receivedQuantity', 'itemQuantity'], where: { purchaseOrderId: grnItem.poId, itemCategory: grnItem.itemCategoryId, itemName: grnItem.itemId, saleOrderId: grnItem.saleOrderId } })
        const poItemsUpdate = await this.poItemRepo.updateReceivedQty(recQty.receivedQuantity, grnItem.acceptedQuantity, grnItem.itemId, grnItem.poId, grnItem.saleOrderId, grnItem.itemCategoryId, manager)


        if (grnItem.saleOrderId) {
          const bulkstockDetails = await this.stockService.getInventoryStockQty({
            saleOrderId: undefined, itemCategoryId: grnItem.itemCategoryId, itemId: grnItem.itemId
          }
          );
          let existingQty = 0;
          if (bulkstockDetails.status) {
            if (bulkstockDetails.data.physicalQuantity > 0) {
              existingQty = bulkstockDetails.data.physicalQuantity;
            }
          }
          //received qty updation in BOM against saleorder and item
          const bomItemUpdate: boolean = await this.saleService.updateBomQty(new BomUpdateRequest(grnItem.itemId, grnItem.saleOrderId, grnItem.acceptedQuantity, existingQty))

          if (!bomItemUpdate) {
            throw new ErrorResponse(11106, 'Something went wrong in updation of BOM Received Quantity');

          }

          //updation of 
          const soTrackUpdate = await this.saleService.updateSoTrackPmStatus(new SoRequest(grnItem.saleOrderId, itemcategoryId))

          const latestUpdatedQty = Number(recQty.receivedQuantity) + Number(grnItem.acceptedQuantity);
        }

        // if(latestUpdatedQty == recQty.itemQuantity){

        // }

        

      }

      const poItemsdata = await manager.getRepository(PoItems).find({ select: ['receivedQuantity', 'itemQuantity'], where: { purchaseOrderId: grnDto.poId, isActive: true } })
      const qtyFlagSet = new Set<boolean>();

      for (const poItem of poItemsdata) {

        if (Number(poItem.receivedQuantity) >= Number(poItem.itemQuantity)) {
          qtyFlagSet.add(true)
        } else {
          qtyFlagSet.add(false)
        }
      }
      let statusVal = StatusEnum.IN_PROGRESS;
      if (!(qtyFlagSet.has(false))) {
        statusVal = StatusEnum.CLOSED;
      }
      const existingPodata =  await manager.getCustomRepository(PoRepository).findOne({purchaseOrderId:grnDto.poId})
      let maxGrnDate = grnDto.grnDate
      if(existingPodata){
        if(existingPodata.maxGrnDate == null || existingPodata.maxGrnDate < grnDto.grnDate){
          maxGrnDate = grnDto.grnDate
        }
      }
      const poStatusUpdate = await manager.getCustomRepository(PoRepository).update({ purchaseOrderId: grnDto.poId }, { status: statusVal,maxGrnDate:maxGrnDate});
      if(!poStatusUpdate){
        throw new ErrorResponse(11106, 'Something went wrong in status updation');
      }
      


      await manager.completeTransaction();


      // const grnQtyForPo = await this.grnRepo.getGrnQtyForPo(savedGrnDto.poId)

      if (savedEntity) {

        if (savedGrnDto) {
          const conManager = getManager();
          let query = "select SUM(item_quantity) from "+appSettings.procure_db +".purchase_order_items poi left join "+appSettings.procure_db+".purchase_order po on po.purchase_order_id = poi.purchase_order_id where poi.purchase_order_id ="+savedGrnDto.poId+" group by poi.sale_order_id order by poi.sale_order_id";
          let queryResult = await conManager.query(query);
          console.log("queryResult"+queryResult);

          let grnCount = "Select g.vendor_id AS vendorId,v.vendor_name AS vendorName,soi.po_number AS soNo,it.item_name AS item,SUM(po_quantity) AS poQuantity, SUM(accepted_quantity) AS acceptedQuantity, (((SUM(accepted_quantity) / Sum(po_quantity))*100)-100) AS excessPercentage, g.grn_no AS grnNo, u.unit_name AS unitName,po.po_number AS poNumber,g.grn_no AS grnNumber,g.grn_id AS grnId from "+appSettings.procure_db+".grn_items gi left join "+appSettings.sales_db+".so_invoice_details soi on soi.sale_order_id = gi.sale_order_id left join "+appSettings.procure_db+".grn g on g.grn_id = gi.grn_id left join "+appSettings.masters_db+".vendors v on v.vendor_id = g.vendor_id left join "+appSettings.masters_db+".unitcodes u on u.unit_code_id = g.unit_id left join "+appSettings.procure_db+".purchase_order po on po.purchase_order_id = gi.po_id left join "+appSettings.masters_db+".items it on it.item_id = gi.item_id where gi.po_id = "+savedGrnDto.poId+" group by gi.sale_order_id,gi.grn_item_id having excessPercentage > 5 order by gi.sale_order_id";
          let grnCountResult = await conManager.query(grnCount);
          console.log("grnCountResult"+grnCountResult);
          const perFlagSet = new Set<boolean>();
          
          let poNumber = undefined;
          let soNumber = undefined;
          let grnNumber = undefined;
          let grn = undefined;
          let unitName = undefined;
          let item = undefined;
          let vendorName = undefined;
          let poQty = 0;
          let grnQty = 0;
          let excessPer = 0;
          let messageContent = '';
          const time = moment().format("DD-MM-YYYY HH:mm")
          for (const res of grnCountResult) {
            console.log("res res"+res.grnId);
              soNumber = res.soNo;
              item = res.item;
              poNumber = res.poNumber;
              grnNumber = res.grnNumber;
              unitName = res.unitName;
              poQty = res.poQuantity;
              vendorName = res.vendorName;
              grnQty = Math.round(res.acceptedQuantity);
              excessPer = Math.round(res.excessPercentage);
              grn = res.grnId;
              
              let message = "\\n*Item :* " + (item != undefined ? item : 'No Data\\n')+
              "\\n*PO Quantity :* " + (poQty > 0 ? poQty : 'No Data\\n') +
              "\\n*Grn Quantity :* " + (grnQty > 0 ? grnQty : 'No Data\\n')+
              "\\n*Excess Perc% :* " + (excessPer > 0 ? excessPer : 'No Data\\n') + '\\n';
              messageContent += message
              // messageContent.push(message);
          }
          console.log("messageContent");
          console.log(messageContent);

          let urlMsg = '*click the below link for detail view*';
          let reportUrl = appSettings.whatsapp_redirection_url+'/grn-detail-view/'+grn;
          console.log("reportUrl"+reportUrl)
          if(grnCountResult.length > 0) {
          const alertMessage = await new BroadCastMessageRequest(27,
             time +
            " \n*Unit :* " + (unitName!=undefined ? unitName : 'No Data\n') +
            " \n*Vendor :* " + (vendorName!=undefined ? vendorName : 'No Data\n') +
            " \n*GRN Number :* " + (grnNumber!=undefined ? grnNumber : 'No Data\n') +
            "\n*PO Number :* " + (poNumber != undefined ? poNumber : 'No Data\n') +
            "\n*SO Number :* " + (soNumber !=undefined ? soNumber : 'No Data\n') + '\n' +
            messageContent + '\n\n' + urlMsg+ '\n' + reportUrl + '\n', [whatsApp.UsageReport])
            // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(alertMessage);
             //whatsapp broadcast API calling to facebook

             const parameters = [
              { "type": "text", "text": time},
              { "type": "text", "text": unitName!=undefined ? unitName : 'No Data'},
              { "type": "text", "text": vendorName!=undefined ? vendorName : 'No Data'},
              { "type": "text", "text": grnNumber!=undefined ? grnNumber : 'No Data'},
              { "type": "text", "text": poNumber != undefined ? poNumber : 'No Data'},
              { "type": "text", "text": soNumber != undefined ? soNumber : 'No Data'},
              { "type": "text", "text": messageContent},
            ];
            console.log('parameters',parameters)
            const contacts = whatsApp.contacts;
            let statusFlag
            for(const contact of contacts){
                const req = await new MessageParameters(contact, 'proc_grn_excess_alert', parameters,'en_us')

                const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
            console.log('messageStatus',messageStatus)

                if(!messageStatus.status){
                    statusFlag = false
                    break
                }else{
                  statusFlag = true
                  const whatsapplogDto = new WhatsAppLogDto(contact,'proc_grn_excess_alert','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.procurementmoduleId)
                  await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                }
          console.log(messageStatus);
          }
        }
          const response = new grnResponse(true, isUpdate ? 11100 : 11101, isUpdate ? 'GRN Updated Successfully' : 'GRN Created Successfully', savedGrnDto)
          return response;
        } else {
          throw new ErrorResponse(11106, 'Something Went wrong!');
        }
      }else{
        throw new ErrorResponse(11106, 'Something Went wrong in saving!');
      }
    }
    catch (error) {
      manager.releaseTransaction();
      throw error;
    }
  }

  async getGrnQtyByPoId(poReq: GrnQtyRequest): Promise<GrnQtyResponseModel> {
    //  console.log(employeeId);
    try {

      const qty = await this.grnRepo.getGrnQty(poReq);
      if (qty) {
        const response = new GrnQtyResponseModel(true, 11058, 'qty retreived', new grnQtyDto(qty.quantity))
        return response;
      } else {
        const response = new GrnQtyResponseModel(true, 11058, 'qty retreived', new grnQtyDto(0))
        return response;
      }
    } catch (error) {
      return error;
    }


  }

  async getGrnById(grnId: number): Promise<Grn> {
    //  console.log(employeeId);
    const Response = await this.grnRepository.findOne({
      where: { grnId: grnId },
    });
    // console.log(employeeResponse);
    if (Response) {
      return Response;
    } else {
      return null;
    }
  }

  async getAllGrnData(req?: UnitRequest): Promise<AllGrnResponseModel> {
    // let grndata: Grn[]
    console.log(req,'unit req')
    let concatString = ''
    if (req) {

      if (req.unitId && req.unitId != 5) {
        concatString = `where g.unit_id = ` + req.unitId;
      }
      const manager = getManager();

      let query = `SELECT count(*),g.grn_id as grnId,so.sale_order_no,soi.po_number,g.unit_id as unitId,p.status as poStatus,p.po_type as poType,p.po_number as poNumber,v.vendor_name as vendor,g.grn_no as grnNumber,g.grn_date as grnDate,g.inv_no as invoiceNumber,g.invoice_date as InvoiceDate,group_concat(soi.po_number) as poNumbers,u.unit_name as unitName FROM ` + grnTable + ` g
        LEFT JOIN `+ poTable + ` p ON g.po_id=p.purchase_order_id 
        LEFT JOIN `+ poItemsTable + ` pi ON p.purchase_order_id=pi.purchase_order_id 
        LEFT JOIN `+ soTable + ` so ON pi.sale_order_id=so.sale_order_id 
        LEFT JOIN `+ soInvTable + ` soi ON pi.sale_order_id=soi.sale_order_id 
        LEFT JOIN `+ vendorsTable + ` v ON v.vendor_id=p.vendor_name 
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id=g.unit_id
        `+ concatString + ` group by g.grn_id `;
        query = query + ' ORDER BY g.created_at DESC '
      const grnData = await manager.query(query);
      const res= new AllGrnResponseModel(true, 1108, 'GRN Details Retrieved Succesfully', grnData);
      // const newLogDto = new LogsDto(1,'view grn details', 'GrnItems', 0, true, '','')
      //       let res = await this.logService.createLog(newLogDto);
      //       console.log(res);
      return res
      // } else {
      //   const grndata = await this.grnRepository.find({
      //     relations: ['grnItemsInfo'],
      //     order: { createdAt: "DESC" },
      //   });
      //   return new AllGrnResponseModel(true, 1108, 'GRN Details Retrieved Succesfully', grndata);

      // }
    }
    // if (grndata) {
    // } else {
    //   throw new ErrorResponse(9999, 'Failed To Get GRN Info')
    // }
  }

  /**
   * gets all  val addition one types details  
   * @returns all the val addition one type details .
   */
  async getAllGrnDetails(req?: UnitRequest): Promise<AllGrnResponseModel> {
    let grndata: Grn[]
    if (req) {
      if (req.unitId) {
        grndata = await this.grnRepository.find({
          where: { unitId: req.unitId },
          relations: ['grnItemsInfo'],
          order: { createdAt: "DESC" },
        });

      } else {
        grndata = await this.grnRepository.find({
          relations: ['grnItemsInfo'],
          order: { createdAt: "DESC" },
        });
      }
    }
    if (grndata) {
      const grnInfo: AllGrnDto[] = [];
      for (const grn of grndata) {
        // let poDetails =null;
        // let poData
        // if(grn.poId){
        //     const poReq: PoRequest = {
        //         purchaseOrderId: grn.poId
        //     }
        //     poDetails = await this.poService.getPoNumberById(poReq);
        //     poData = new PoNumbersModel(grn.poId,poDetails.poNumber);
        // }
        const poDetails = await this.poService.getPoNumberById(grn.poId);
        let soNumber;
        let soId;
        let pmStatus;
        if (poDetails) {
          let saleOrderDetails = null;
          let soTrackData = null;
          if (poDetails.saleOrderId) {
            const soReq: saleOrder = {
              saleOrderId: poDetails.saleOrderId
            }
            saleOrderDetails = await this.saleService.getSaleOrderDetailsForId(soReq);
            soNumber = saleOrderDetails.saleOrderNumber;
            soId = poDetails.saleOrderId;
            soTrackData = await this.saleService.getPmStatus(soReq);
            pmStatus = soTrackData.data.pmStatus;
          }
        }
        const poData = new PoNumbersModel(grn.poId, poDetails.poNumber);

        const vendorDetails = await this.vendorService.getVendorDataById({ vendorId: grn.vendorId });
        // console.log(vendorDetails.data);
        // logIntermediateObjects({logger: this.logger, functionName: this.vendorService.getVendorDataById.name, loggingMode: 'trace'}, {vendorDetails});
        const vendorData = new PoVendorDataModel(grn.vendorId, vendorDetails.data.vendorCode, vendorDetails.data.vendorName, vendorDetails.data.contactPerson, vendorDetails.data.contactNumber, vendorDetails.data.street, vendorDetails.data.apartment, vendorDetails.data.city, vendorDetails.data.postalCode);

        const grnItems: grnItemsDataModel[] = [];

        // console.log(vendorData);
        for (const grnItem of grn.grnItemsInfo) {
          const itemcategorydata = await this.itemCategoryService.getItemCategoryById({ itemCategoryId: grnItem.itemCategoryId });

          //   // logIntermediateObjects({logger: this.logger, functionName: this.itemCategoryService.getItemCategoryById.name, loggingMode: 'trace'}, {itemcategorydata});

          const itemdata = await this.itemService.getItemById({ itemId: grnItem.itemId });
          const sizeData = await this.sizeService.getSizeDataById({ sizeId: grnItem.sizeId });

          const taxData = await this.taxService.getTaxForId({ taxId: grnItem.taxPercentage });


          // let sizeData = new SizesDropDownDto(1, '5*2');

          // let QtyData = await this.grnService.getGrnQtyByPoId({ purchaseOrderId: poIdReq.purchaseOrderId, itemCategoryId: grnItem.itemCategory, itemId: grnItem.itemName });
          //   console.log('show')
          //   console.log(QtyData)

          //   // logIntermediateObjects({logger: this.logger, functionName: this.itemService.getItemById.name, loggingMode: 'trace'}, {itemdata});

          const grnItemObject = new grnItemsDataModel(
            grnItem.grnId,
            itemcategorydata,
            itemdata,
            sizeData,
            grnItem.poQuantity,
            grnItem.acceptedQuantity,
            grnItem.rejectedQuantity,
            grnItem.receivedQuantity,
            grnItem.unitPrice,
            grnItem.discountPercentage,
            grnItem.discountAmount,
            taxData,
            grnItem.taxAmount,
            grnItem.totalAmount,
            grnItem.createdUser,
            grnItem.updatedUser,
            grnItem.status,
          )
          grnItems.push(grnItemObject);
        }

        const grnModel = new AllGrnDto(grn.grnId, grn.grnDate, grn.InvoiceDate, grn.grnNumber, grn.unitId, grn.invoiceNumber, poData, grn.totalQuantity, grn.totalDiscount, grn.totalTax, grn.totalCost, grn.remarks, grn.approvar, grn.status, grn.createdUser, grn.updatedUser, vendorData, grnItems, poDetails.poStatus, poDetails.poType, soNumber, soId, pmStatus, poDetails.poNumber);
        grnInfo.push(grnModel)
      }
      return new AllGrnResponseModel(true, 1108, 'GRN Details Retrieved Succesfully', grnInfo);
    } else {
      throw new ErrorResponse(9999, 'Failed To Get GRN Info')
    }
  }

  async getGrnDataById(grnIdReq: GrnIdRequest): Promise<GrnDetailViewResponseModel> {

    const grndata = await this.grnRepo.getGrnData(grnIdReq.grnId);
    // console.log(grndata);
    let poData;
    if (grndata) {
      let poDetails = null;
      if (grndata.poId) {
        const poReq: PoRequest = {
          purchaseOrderId: grndata.poId
        }
        poDetails = await this.poService.GetPoDataDetailsForPoId(poReq);
        poData = new PoNumbersModel(grndata.poId, poDetails.data.purchaseOrderNo);
      }
      // console.log(poDetails);
      const grnItems: grnItemsDataModel[] = [];
      const vendorDetails = await this.vendorService.getVendorDataById({ vendorId: grndata.vendorId });
      // console.log(vendorDetails.data);
      // logIntermediateObjects({logger: this.logger, functionName: this.vendorService.getVendorDataById.name, loggingMode: 'trace'}, {vendorDetails});
      const vendorData = new PoVendorDataModel(grndata.vendorId, vendorDetails.data.vendorCode, vendorDetails.data.vendorName, vendorDetails.data.contactPerson, vendorDetails.data.contactNumber, vendorDetails.data.street, vendorDetails.data.apartment, vendorDetails.data.city, vendorDetails.data.postalCode);


      // console.log(vendorData);
      for (const grnItem of grndata.grnItemsInfo) {
        const itemcategorydata = await this.itemCategoryService.getItemCategoryById({ itemCategoryId: grnItem.itemCategoryId });

        //   // logIntermediateObjects({logger: this.logger, functionName: this.itemCategoryService.getItemCategoryById.name, loggingMode: 'trace'}, {itemcategorydata});

        const itemdata = await this.itemService.getItemById({ itemId: grnItem.itemId });
        const sizeData = await this.sizeService.getSizeDataById({ sizeId: grnItem.sizeId });
        // const sizeData = new SizesDropDownDto(1, '5*2');
        const taxData = await this.taxService.getTaxForId({ taxId: grnItem.taxPercentage });
        const saleOrderDetails = await this.saleService.getSaleOrderDetailsForId({ saleOrderId: grnItem.saleOrderId });
        console.log('saleOrderDetailsdfghjkl');
        console.log(saleOrderDetails);



        // let QtyData = await this.grnService.getGrnQtyByPoId({ purchaseOrderId: poIdReq.purchaseOrderId, itemCategoryId: grnItem.itemCategory, itemId: grnItem.itemName });
        //   console.log('show')
        //   console.log(QtyData)

        //   // logIntermediateObjects({logger: this.logger, functionName: this.itemService.getItemById.name, loggingMode: 'trace'}, {itemdata});

        const grnItemObject = new grnItemsDataModel(
          grnItem.grnId,
          itemcategorydata,
          itemdata,
          sizeData,
          grnItem.poQuantity,
          grnItem.acceptedQuantity,
          grnItem.rejectedQuantity,
          grnItem.receivedQuantity,
          grnItem.unitPrice,
          grnItem.discountPercentage,
          grnItem.discountAmount,
          taxData,
          grnItem.taxAmount,
          grnItem.totalAmount,
          grnItem.createdUser,
          grnItem.updatedUser,
          grnItem.status,
          saleOrderDetails.saleOrderNumber,
          saleOrderDetails.poNumber,
        )
        grnItems.push(grnItemObject);
      }

      const grndataModel = new GrnDetailViewModel(grndata.grnId, grndata.grnDate, grndata.InvoiceDate, grndata.grnNumber, grndata.invoiceNumber, poData, grndata.totalQuantity, grndata.totalDiscount, grndata.totalTax, grndata.totalCost, grndata.remarks, grndata.approvar, grndata.status, 'Admin', 'Admin', vendorData, grnItems)
      const response = new GrnDetailViewResponseModel(true, 1108, ' GRN Details Retrieved Succesfully', grndataModel);
      return response;
    } else {
      throw new ErrorResponse(9999, 'Failed To Get GRN Info')
    }
  }

  async getGrnDataByIdForReturn(grnIdReq: GrnIdRequest): Promise<GrnItemReturnResponse> {
    const grndata: Grn = await this.grnRepo.getGrnData(grnIdReq.grnId);
    if (grndata) {
      const grnReturnData = new GrnDetailsForReturn();
      grnReturnData.grnDate = grndata.grnDate
      grnReturnData.grnId = grndata.grnId;
      grnReturnData.grnNumber = grndata.grnNumber;
      grnReturnData.invoiceDate = grndata.InvoiceDate;
      grnReturnData.invoiceNumber = grndata.invoiceNumber;
      grnReturnData.vendorId = grndata.vendorId;
      const vendorDetails = await this.vendorService.getVendorDataById({ vendorId: grndata.vendorId });
      grnReturnData.vendorName = vendorDetails.data.vendorName;
      const items: GrnItemsForReturn[] = [];
      for (const grnItem of grndata.grnItemsInfo) {
        // get available stock 
        const getStock = await this.stockRepo.findOne({ where: { stockId: grnItem.stockId } });
        if (Number(getStock.physicalQuantity) > 0) {
          const item = new GrnItemsForReturn();
          // get item Category, item Sub Category, item, 
          const itemCategoryReq = new ItemCategoryReq(grnItem.itemCategoryId);
          const itemCategoryDetails = this.itemCategoryService.getItemCategoryById(itemCategoryReq);
          if (!itemCategoryDetails) {
            throw new ErrorResponse(1111, 'Failed to Get Item Category');
          }

          // get item details for item id 
          const itemReq = new ItemRequest(grnItem.itemId);
          const itemDetails = this.itemService.getItemById(itemReq);
          if (!itemDetails) {
            throw new ErrorResponse(1111, 'Failed to Get Item');
          }

          // const size = new SizeRequest(grnItem.sizeId);
          // const sizeDetails = this.sizeService.getSizeDataById(size);
          // if (!size) {
          //   throw new ErrorResponse(1111, 'Failed to Get Size');
          // }

          // get item sub category details for item sub category id
          const itemSubCategoryReq = new ItemSubCategoryRequest(grnItem.itemSubCategoryId);
          const itemSubCategoryDetails = this.subCategoryService.getItemSubCategoryForId(itemSubCategoryReq);
          if (!itemSubCategoryDetails) {
            throw new ErrorResponse(1111, 'Failed to Get Item Category');
          }

          // get Tax
          const taxData = this.taxService.getTaxForId({ taxId: grnItem.taxPercentage });
          const remainingQty = grnItem.receivedQuantity - grnItem.returnedQuantity;
          const qty = (getStock.physicalQuantity < remainingQty) ? getStock.physicalQuantity : remainingQty;


          await Promise.all([itemCategoryDetails, itemDetails, itemSubCategoryDetails, taxData]).then(res => {
            const itemCategory = (res[0]) ? res[0] : null;
            const itemSubCategory = (res[2]) ? res[2] : null;
            const itemData = (res[1]) ? res[1] : null;
            // const size = (res[2]) ? res[2] : null;
            const tax = (res[3]) ? res[3] : null;

            item.itemCategoryId = itemCategory.itemCategoryId;
            item.itemCategoryName = itemCategory.itemCategory;
            item.itemSubCategoryId = itemSubCategory.itemSubCategoryId;
            item.itemSubCategoryName = itemSubCategory.itemSubCategory;
            item.itemId = itemData.itemId;
            item.itemName = itemData.itemName;
            // item.sizeId = size.sizeId;
            // item.sizeName = size.sizeName;
            const itemCost = qty * grnItem.unitPrice;
            //discount
            item.discountPercentage = Number(grnItem.discountPercentage);
            item.discountAmount = Number((itemCost) * (grnItem.discountPercentage / 100));

            //tax
            item.taxPercentage = Number(tax.taxPercentage);
            item.taxAmount = Number(((itemCost) - item.discountAmount) * (tax.taxPercentage / 100));

            item.grnItemId = grnItem.grnItemId;
            item.stockId = grnItem.stockId;
            item.grnReceivedQty = Number(remainingQty);
            item.grnReturnQty = Number(grnItem.returnedQuantity);
            item.availQty = Number(getStock.physicalQuantity);
            item.unitPrice = Number(grnItem.unitPrice);
            item.grnTotalReturnPrice = Number((itemCost - item.discountAmount + item.taxAmount));
            item.grnReturnQty = Number(qty);
            items.push(item);
          })
        }
      }
      grnReturnData.grnItems = items;
      return new GrnItemReturnResponse(true, 1111, 'Grn items Retrieved Successfully', grnReturnData)
    } else {
      return new GrnItemReturnResponse(false, 9999, 'No Data Found')
    }

  }

  async getAllActiveGrnNumbers(req?: UnitRequest): Promise<GrnNumberResponseModel> {
    let wherCondition = {};
    if (req.unitId != 5) {
      wherCondition = { where: { unitId: req.unitId } };
    }
    const grnNumbers = await this.grnRepository.find(
      {
        ...wherCondition,
        select: ['grnId', 'grnNumber'],
        order: { grnId: "DESC" }
      });
    if (grnNumbers.length > 0) {
      grnNumbers.map(grn => new GrnNumberDto(grn.grnId, grn.grnNumber));
      return new GrnNumberResponseModel(true, 11059, 'Grn Numbers retrived successfully', grnNumbers)
    } else {
      throw new ErrorResponse(99998, 'Grn Numbers not Found');
    }
  }

  async getGrnReturnAutoFillDataByGrnNumber(grnIdReq: GrnIdRequest): Promise<GrnReturnAutoFillModel> {
    const grndata = await this.grnRepo.findOne({ where: { grnId: grnIdReq.grnId } });
    const obj = new GrnReturnAutoFillDto(undefined, grndata.grnId, grndata.grnNumber, 'BAJ-VSP-ANAKAPALLI', grndata.InvoiceDate, 'INV#123', 2, 100, 'BAJ-VSP-ANAKAPALLI//1', 'DC/BAJ-VSP-HEAD OFFICE/2018-19/1');
    return new GrnReturnAutoFillModel(true, 1, 'Grn Return auto fill data', obj);
  }

  async getGrnItemReceivedQtyByGrnIdandItem(grnItemReq: GrnItemReceivedQtyRequest): Promise<GrnItemReceivedQtyResponse> {
    return new GrnItemReceivedQtyResponse(true, 11, '', 4)
  }


  async getAllGrnReport(req?: GrnReportRequest): Promise<AllGrnReportResponse> {
    try {
      const manager = getManager();
      let query = `SELECT g.grn_date as grnDate,g.grn_no as grnNumber,g.inv_no as invoiceNumber,gi.po_quantity as grnQty,gi.po_id as poId, vendor.vendor_name as vendorName,po.purchase_order_date as poDate,po.po_number as poNumber,so_invoice.po_number as saleOrder,so_invoice.sale_order_id,g.grn_Id,g.unit_id,u.unit_name as plant,po.po_type as poType,isc.item_sub_category as itemSubCategory,i.item_name as item,g.invoice_date as invDate,i.item_id,gi.accepted_quantity as acptQty,gi.received_quantity as rcvdQty,gi.rejected_quantity as rjctQty,gi.unit_price as unitPrice ,t.tax_name AS taxPer, gi.tax_amount as taxAmount,gi.tot_amount as totalAmount, gi.grn_item_id,g.created_at as createdDate,(((gi.accepted_quantity / gi.po_quantity)*100)) AS excessPercentage FROM ` + appSettings.procure_db + `.grn g
      LEFT JOIN ` + appSettings.procure_db + `.grn_items gi ON gi.grn_id = g.grn_id
      LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = gi.item_sub_category_id
      LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = gi.item_id
      LEFT JOIN ` + appSettings.procure_db + `.purchase_order po ON po.purchase_order_id = gi.po_id
      LEFT JOIN ` + appSettings.procure_db + `.purchase_order_items po_item ON po_item.purchase_order_id = g.po_id
      LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = g.unit_id
      LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details so_invoice ON so_invoice.sale_order_id = gi.sale_order_id
      LEFT JOIN ` + appSettings.masters_db + `.vendors vendor ON vendor.vendor_id = g.vendor_id
      LEFT JOIN ` + appSettings.masters_db + `.taxes t ON t.tax_id = gi.tax_per
      WHERE g.grn_id > 0 `
      if (req.fromDate != undefined) {
        query = query + ' and g.grn_date between  "' + req.fromDate + '" and "' + req.toDate + '"';
      }
      if (req.selectedCreatedFromDate != undefined) {
        query = query + ' and date(g.created_at) >= "' + req.selectedCreatedFromDate + '" and  date(g.created_at) <= "' + req.selectedCreatedToDate + '"';
      }
      if (req.saleOrderId) {
        query = query + ' and so_invoice.sale_order_id = ' + req.saleOrderId;
      }
      if (req.grnNumber) {
        query = query + ' and g.grn_Id = ' + req.grnNumber;
      }
      if (req.poNumber) {
        query = query + ' and gi.po_id = ' + req.poNumber;
      }
      if (req.vendorName) {
        query = query + ' and vendor.vendor_id = ' + req.vendorName;
      }
      if (req.unitId && req.unitId != 5) {
        query = query + ' and g.unit_id = ' + req.unitId;
      }
      if (req.itemSubCategoryId) {
        query = query + ' and gi.item_sub_category_id = "' + req.itemSubCategoryId + '"';
      }
      if (req.poType) {
        query = query + ' and po.po_type = "' + req.poType + '"';
      }
      if (req.itemNameId) {
        query = query + ' and i.item_id = ' + req.itemNameId;
    }
    if (req.excessPercent) {
        query = query + ' and (((gi.accepted_quantity / gi.po_quantity)*100)) > ' + req.excessPercent
    }

      //  if (req.invoiceNumber) {
      //   query = query + ' and g.invoiceNumber = ' + req.invoiceNumber;
      //  }
      query = query + ` GROUP BY gi.grn_item_id ORDER BY g.grn_date DESC `
      const data = await manager.query(query)
      if (data.length > 0) {
        const response = new AllGrnReportResponse(true, 11208, "GRN Report retrieved successfully", data);
        return response;
      } else {
        throw new AllGrnReportResponse(false,99998, 'No Record Found');
      }
    } catch (err) {
      return err
    }

  }
  async getSoDropForGrnReport(req:UnitRequest):Promise<CommonResponse>{
    const manager = getManager()
    let query = ` SELECT si.sale_order_id as saleOrderId , si.po_number AS soNumber ,  g.unit_id FROM ` + appSettings.procure_db + `.grn g
    LEFT JOIN ` + appSettings.procure_db + `.grn_items gi ON gi.grn_id = g.grn_id
    LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = gi.sale_order_id
    WHERE si.sale_order_id> 0 `;
    if(req.unitId && req.unitId != 5){
        query = query + ' and g.unit_id = ' + req.unitId;
     }
     query = query + ` GROUP BY si.sale_order_id  ORDER BY soNumber `;
    const data = await manager.query(query);
    if(data){
      return new CommonResponse(true,1421,'Data retrieved successfully',data)
    }else{
     return new CommonResponse(false,1421,'No data')
    }
 }
 async getPoDropForGrnReport(req:UnitRequest):Promise<CommonResponse>{
  const manager = getManager()
  let query = ` SELECT  g.po_id  as purchaseOrderId , po.po_number AS poNumber , g.unit_id FROM ` + appSettings.procure_db + `.grn g
  LEFT JOIN ` + appSettings.procure_db + `.grn_items gi ON gi.grn_id = g.grn_id
  LEFT JOIN ` + appSettings.procure_db + `.purchase_order po ON po.purchase_order_id = gi.po_id
  LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = gi.sale_order_id
  WHERE g.po_id> 0 `;
  if(req.unitId && req.unitId != 5){
      query = query + ' and g.unit_id = ' + req.unitId;
   }
   query = query + ` GROUP BY g.po_id `;
  const data = await manager.query(query);
  if(data){
    return new CommonResponse(true,1421,'Data retrieved successfully',data)
  }else{
   return new CommonResponse(false,1421,'No data')
  }
}
async getItemSubDropForGrnReport(req:UnitRequest):Promise<CommonResponse>{
  const manager = getManager()
  let query = ` SELECT isc.item_sub_category_id AS itemSubCategoryId, isc.item_sub_category AS itemSubCategory , g.unit_id FROM ` + appSettings.procure_db + `.grn g
  LEFT JOIN ` + appSettings.procure_db + `.grn_items gi ON gi.grn_id = g.grn_id
  LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = gi.item_sub_category_id
  WHERE isc.item_sub_category_id> 0 `;
  if(req.unitId && req.unitId != 5){
      query = query + ' and g.unit_id = ' + req.unitId;
   }
   query = query + ` GROUP BY isc.item_sub_category_id `;
  const data = await manager.query(query);
  if(data){
    return new CommonResponse(true,1421,'Data retrieved successfully',data)
  }else{
   return new CommonResponse(false,1421,'No data')
  }
}
async getItemDropForGrnReport(req:UnitRequest):Promise<CommonResponse>{
  const manager = getManager()
  let query = ` SELECT i.item_id AS itemId , i.item_name AS item , g.unit_id FROM ` + appSettings.procure_db + `.grn g
  LEFT JOIN ` + appSettings.procure_db + `.grn_items gi ON gi.grn_id = g.grn_id
  LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = gi.item_id
  WHERE i.item_id> 0 `;
  if(req.unitId && req.unitId != 5){
      query = query + ' and g.unit_id = ' + req.unitId;
   }
   query = query + ` GROUP BY i.item_id `;
  const data = await manager.query(query);
  if(data){
    return new CommonResponse(true,1421,'Data retrieved successfully',data)
  }else{
   return new CommonResponse(false,1421,'No data')
  }
}
async getVendorDropForGrnReport(req:UnitRequest):Promise<CommonResponse>{
  const manager = getManager()
  let query = ` SELECT g.vendor_id as vendorId , vendor.vendor_name AS vendorName , g.unit_id FROM ` + appSettings.procure_db + `.grn g
  LEFT JOIN ` + appSettings.masters_db + `.vendors vendor ON vendor.vendor_id = g.vendor_id
  WHERE g.vendor_id> 0 `;
  if(req.unitId && req.unitId != 5){
      query = query + ' and g.unit_id = ' + req.unitId;
   }
   query = query + ` GROUP BY g.vendor_id `;
  const data = await manager.query(query);
  if(data){
    return new CommonResponse(true,1421,'Data retrieved successfully',data)
  }else{
   return new CommonResponse(false,1421,'No data')
  }
}

  async getTransferredSosDataForGrnGrid(req?: UnitRequest){
    
      const transferredSoIds = await this.soService.getTransferredSaleOrders();
      if(transferredSoIds.status){
           //below line using to convert array of objets to array of properties
            const arrayOfSoIds = transferredSoIds.data.map(({saleOrderId}) => saleOrderId)
            let concatString = ''
            if (req) {
        
              if (req.unitId && req.unitId != 5) {
                concatString = `and g.unit_id = ` + req.unitId;
              }
            }
              const manager = getManager();
        const query = `SELECT count(*),g.grn_id as grnId,so.sale_order_no,soi.po_number,g.unit_id as unitId,p.status as poStatus,p.po_type as poType,p.po_number as poNumber,v.vendor_name as vendor,g.grn_no as grnNumber,g.grn_date as grnDate,g.inv_no as invoiceNumber,g.invoice_date as InvoiceDate,group_concat(soi.po_number) as poNumbers,u.unit_name as unitName FROM ` + grnTable + ` g
                LEFT JOIN `+ poTable + ` p ON g.po_id=p.purchase_order_id 
                LEFT JOIN `+ poItemsTable + ` pi ON p.purchase_order_id=pi.purchase_order_id 
                LEFT JOIN `+ soTable + ` so ON pi.sale_order_id=so.sale_order_id 
                LEFT JOIN `+ soInvTable + ` soi ON pi.sale_order_id=soi.sale_order_id 
                LEFT JOIN `+ vendorsTable + ` v ON v.vendor_id=p.vendor_name 
                LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id=g.unit_id
                where  pi.sale_order_id IN (` + arrayOfSoIds.toString() + `) ` + concatString + `  group by g.grn_id`;
              const grnData = await manager.query(query);
       if (grnData && grnData.length > 0) {
          return new CommonResponse(true, 1525, 'Grn Details Retrieved Successfully', grnData);
      } else {
          throw new ErrorResponse(9999, 'No Data Found');
      }
      }else{
          throw new ErrorResponse(9999, 'No Transferred SaleOrders  Found');
      }
 }

   



  // async getAllGrnReport(req?: GrnReportRequest): Promise<AllGrnReportResponse> {
  //   try {
  //     const grnInfo = this.grnRepo
  //       .createQueryBuilder('Grn')
  //       .select([
  //         'Grn.grn_date as grnDate,Grn.grn_no as grnNumber, Grn.inv_no as invoiceNumber, Grn.total_cost as totalCost, Grn.po_id as poId, Grn.vendor_id as vendorId, purchase_order.purchase_order_date as poDate, purchase_order.po_number as poNumber, purchase_order.sale_order_id as saleOrderId '
  //       ])
  //       .leftJoin('purchase_order', 'purchase_order',  'Grn.po_id=purchase_order.purchase_order_id')

  //     if (req) {
  //       if (req.fromDate && req.toDate) {
  //         grnInfo.where('Date(grn_date) between "' + moment(req.fromDate).format('YYYY-MM-DD') + '" and "' + moment(req.toDate).format('YYYY-MM-DD') + '"')
  //       }

  //       if (req.soNumber) {
  //         grnInfo.andWhere('purchase_order.sale_order_id =' + req.soNumber)
  //       }

  //       if (req.poNumber) {
  //         grnInfo.andWhere('Grn.po_id =' + req.poNumber)
  //       }

  //       if (req.vendorName) {
  //         grnInfo.andWhere('vendor_name =' + req.vendorName)
  //       }

  //       if (req.grnNumber) {
  //         grnInfo.andWhere('grn_id =' + req.grnNumber)
  //       }
  //     }
  //     const grnDetails = await grnInfo.getRawMany();
  //     console.log(grnDetails);
  //     if (grnDetails && grnDetails.length > 0) {
  //       console.log(grnDetails);
  //       const grnInformation: AllGrnReportDto[] = [];
  //       for (const grn of grnDetails) {

  //         let saleOrderDetails = null;
  //         let soNumber;
  //         let soId;
  //         let soDate;
  //         if (grn.saleOrderId) {
  //           const soReq: saleOrder = {
  //             saleOrderId: grn.saleOrderId
  //           }
  //           saleOrderDetails = await this.saleService.getSaleOrderDetailsForId(soReq);

  //           soNumber = saleOrderDetails.saleOrderNumber;
  //           soId = grn.saleOrderId;
  //           soDate = saleOrderDetails.soDate
  //           console.log(saleOrderDetails);
  //         }

  //         let vendorDetails = await this.vendorService.getVendorDataById({ vendorId: grn.vendorId });
  //         if (!vendorDetails) {
  //           throw new ErrorResponse(9999, 'didn\'t get vendor info')
  //         }
  //         const vendor = vendorDetails.data.vendorName
  //         console.log(vendorDetails);
  //         const grnModel = new AllGrnReportDto(grn.grnId, grn.grnDate, grn.grnNumber, grn.invoiceNumber, grn.poDate, soDate, grn.totalCost, vendor, grn.createdUser, grn.updatedUser, soNumber, grn.poNumber);
  //         console.log(grnModel);
  //         grnInformation.push(grnModel)
  //       }
  //       return new AllGrnReportResponse(true, 1108, 'GRN Report Retrieved Succesfully', grnInformation);
  //     } else {
  //       return new AllGrnReportResponse(false, 1109, 'No Data Found');
  //     }
  //   } catch (error) {
  //     return error;
  //   }
  //}
  // @Cron('0 19 * * *')
  async getGrnUsage(){
    const manager = getManager();
    try{

      let query=`SELECT puc.unit_name,COUNT(*) AS cnt FROM erpx_dev_procurement.grn g
      LEFT JOIN erpx_dev_masters.unitcodes puc ON puc.unit_code_id = g.unit_id WHERE DATE(g.created_at)=DATE(NOW())
          GROUP BY g.unit_id ORDER BY g.unit_id `
      const gData = await manager.query(query);
      const messageType=new Date();
      const month = messageType.getMonth() + 1
      const GDate=messageType.getFullYear()+'-'+month+'-'+messageType.getDate();
      const time= messageType.toLocaleTimeString()
      let messageStatus
      if(gData.length>0){
        let grnData= GDate+" : "+time+"*\n";
        for(const sd of gData){
            grnData+=sd.unit_name+"   *"+sd.cnt+"*\n";
        }
        //whatsapp broadcast API calling
        messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(5,grnData,[whatsApp.UsageReport]));
  
        // const message =await new MessageRequest(whatsApp.UsageReport,`GRN :${GDate} : ${time}`, grnData, "Schemax")
        // console.log(message);
        // var messageStatus= await this.wpService.sendPersonalMessage(message);
      }else{
        const NoGRNData = GDate+" : "+time+"*\n"+'No Data';
        //whatsapp broadcast API calling
        messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(5,NoGRNData,[whatsApp.UsageReport]));
        //  const message = await new MessageRequest(whatsApp.UsageReport,`GRN :${GDate} : ${time}`, "No data", "Schemax")
        //  console.log(message);
        //  var messageStatus=await this.wpService.sendPersonalMessage(message);
      }
      console.log(messageStatus);
      return new CommonResponse(true, 11108, "Message Sent Successfully", gData)
    }
    catch(error){
      return new CommonResponse(false, 11108, "No data found")
    } 
  }

  async getGrnByPoId(poReq: GrnQtyRequest):Promise<CommonResponse>{
    try {
      const grnDetails = await this.grnRepo.getGrnDataByPoId(poReq);
      if (grnDetails) {
        const response = new CommonResponse(true, 11058, 'data exist',grnDetails)
        return response;
      } else {
        const response = new CommonResponse(true, 11058, 'data not exist')
        return response;
      }
    } catch (error) {
      return error;
    }
    return
  }

  async grninfoforpending(req?: UnitRequest): Promise<CommonResponse>{
    try{
      let concatString = ''
      // if (req) {

      if (req.unitId && req.unitId != 5) {
        concatString = `where g.unit_id = ` + req.unitId;
      }
      const manager= getManager();
      const query = 'SELECT gi.item_sub_category_id AS itemSubCategoryId,gi.unit_price as unitPrice,i.item_category_id AS itemCategoryId,brand AS brandId,gi.item_id AS itemId,g.created_user AS createdUser,s.location_id AS locationId,gi.size_id AS sizeId,gi.po_id AS poId,gi.grn_item_id AS grnItemId,ROUND(SUM(COALESCE(s.quantity, 0))) AS physicalQuantity,g.vendor_id AS vendorId,v.vendor_name AS vendorName,i.item_name AS itemName,g.unit_id AS grnUnitId,g.inv_no AS invoiceNumber,g.grn_no AS grnNo,gi.grn_id AS grnId,gi.stock_id AS stockId,ROUND(received_quantity) AS receivedQuantity ,gi.sale_order_id AS saleOrderId,ROUND((received_quantity - (SUM(COALESCE(quantity, 0))))) AS balance FROM '+appSettings.procure_db+'.`grn_items` gi LEFT JOIN '+appSettings.procure_db+'.`grn` g ON gi.grn_id=g.grn_id LEFT JOIN '+appSettings.masters_db+'.`vendors` v ON g.vendor_id= v.vendor_id LEFT JOIN '+appSettings.masters_db+'.items i ON i.item_id=gi.item_id LEFT JOIN '+appSettings.procure_db+'.`stock_log` s ON s.grn_item_id = gi.grn_item_id ' + concatString +' and g.grn_date > "2023-02-03" and gi.item_category_id = 6 GROUP BY gi.grn_item_id HAVING balance > 0 OR balance IS NULL';
      const result =await manager.query(query)
      if (result) {
        const data= new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
        // const newLogDto = new LogsDto(1,'view grn pending details', 'Grn', 0, true, '','')
        // let res = await this.logService.createLog(newLogDto);
        // console.log(res);

        return data
      } else {
        return new CommonResponse(false, 1111, "Error occure")
  
      }
  
    }catch(err){
      return err;
    }
  }
  async getLocationMappedGrns(req:invoiceNumberRequest):Promise<CommonResponse>{
    // const grndataQty = `select * from `
    return
  }
}





